import { FaDotCircle, FaCheckCircle, FaExternalLinkAlt } from 'react-icons/fa';
import { IoCloseCircle } from 'react-icons/io5';
import { MdAccessTime, MdError } from 'react-icons/md';

import { useJob } from '../../state/jobs';
import { colors } from '../../constants';
import { Loading } from '../loading';

export const State = ({ job, size, color }) => {
  const { state, aborted } = job || {};

  const iconSize = size || 24;

  const icon = {
    waiting: <MdAccessTime size={iconSize} />,
    delayed: <MdAccessTime size={iconSize} />,
    paused: <MdAccessTime size={iconSize} />,
    'waiting-children': <MdAccessTime />,
    active: <Loading size={iconSize} />,
    completed: <FaCheckCircle size={iconSize} color={color || colors.green} />,
    failed: <MdError size={iconSize} color={color || colors.error} />,
  }[state || 'active'];

  const abortedIcon = aborted ? <FaDotCircle size={iconSize} color={color || colors.warning} /> : null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: size / 8 }}>
      {icon}
      {state == 'failed' && job.error && <span>{('' + job.error).substr(0, 200)}</span>}
      {abortedIcon}
    </div>
  );
};
